import React, {Component} from 'react';
import './CalendarPage.css';
import '../../../../../App.css';
import {FormattedMessage} from "react-intl";
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import googleCalendarPlugin from '@fullcalendar/google-calendar';
import {Modal} from "react-bootstrap";
import {EVENT_SOURCES, GOOGLE_CALENDAR_API_KEY} from "../../../../../configuration";
import MetaTags from "react-meta-tags";


class CalendarPage extends Component{
    constructor(props) {
        super(props);
        this.state = {
            eventTitle : '',
            showEvent : false
        };

        this.eventClickInfo = this.eventClickInfo.bind(this);
        this.handleEventShow = this.handleEventShow.bind(this);
        this.onContentChange = this.onContentChange.bind(this);
    }

    eventClickInfo = (info) => {
        info.jsEvent.preventDefault();

        if(info.event.title !== ""){
            this.setState({
                eventTitle : info.event.title
            }, ()=> {
                this.handleEventShow(true);
            })
        }

    };
    handleEventShow = (bool) => {
        this.setState({showEvent : bool});
    };


    componentDidMount() {
        window.scrollTo(0, 0);

        this.onContentChange();
    }

    onContentChange = () => {

        let days  = document.getElementsByClassName("fc-day-number");
        for (let day of days) {
            if(day.innerText.length !== 1){
                day.innerText = day.innerText.replace("日","");
            }

        }

    };


    render() {

        let buttonText = {
            today:    '今日',
            month:    '月',
            week:     '週間',
            day:      '日',
            list:     'リスト'
        };

        return (
            <div className="static-pages">
                <MetaTags>
                    <title>営業日カレンダー｜プリント基板のネット通販｜KITCUT PCB</title>
                    <meta property="title" content="営業日カレンダー｜プリント基板のネット通販｜KITCUT PCB"/>
                    <meta name="title" content="営業日カレンダー｜プリント基板のネット通販｜KITCUT PCB"/>
                    <meta property="description" content="プリント基板のネット通販 KITCUT PCBのプリント基板製造サービス、１枚から量産価格！今すぐ見積スタート、WEBで簡単に見積・注文が可能で生産状況をリアルタイムで表示。" lang="ja" />
                    <meta name="description" content="プリント基板のネット通販 KITCUT PCBのプリント基板製造サービス、１枚から量産価格！今すぐ見積スタート、WEBで簡単に見積・注文が可能で生産状況をリアルタイムで表示。" lang="ja" />
                </MetaTags>
                <div className="background-div">
                    <div className="row">

                        <div>
                            <p className="static-pages-headings">
                                <FormattedMessage id="app.calendar.title"
                                                  defaultMessage="Business Day Calendar"
                                                  description=""
                                />
                            </p>
                        </div>
                        <div className="spacer"></div>
                        <div>


                        </div>

                        <div className="row">
                            <div className="col-padding">

                                <div className="col-md-1 col-1 col-custom-4 calendar-holiday-color">&nbsp;</div>
                                <div className="col-md-3 col-3  col-custom-8 calendar-header">KITCUT PCB 休日</div>
                                <div className="col-md-1 col-1  col-custom-4 calendar-holiday-color1">&nbsp;</div>
                                <div className="col-md-3 col-3 col-custom-8 calendar-header">製造サービス休日</div>
                            </div>
                        </div>

                        <br/>
                        <div className="row iframe-calendar-container-resp">

                            <FullCalendar
                                defaultView = "dayGridMonth"
                                plugins = {[dayGridPlugin, timeGridPlugin, listPlugin, googleCalendarPlugin]}
                                googleCalendarApiKey={GOOGLE_CALENDAR_API_KEY}
                                eventSources ={EVENT_SOURCES}
                                eventClick = {this.eventClickInfo}
                                locale = "ja"
                                buttonText = {buttonText}
                                height= {650}
                                eventRender = {this.onContentChange}
                            />
                        </div>

                    </div>
                </div>
                <Modal show={this.state.showEvent} onHide={()=> this.handleEventShow(false)} dialogClassName="event-details-modal">
                    <Modal.Header closeButton>
                        <h4><b>営業日カレンダーイベントの詳細</b></h4>

                    </Modal.Header>
                    <Modal.Body>
                        <div>
                            {this.state.eventTitle}
                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        <button className="pull-right btn btn-success" onClick={()=> this.handleEventShow(false)}>閉じる</button>

                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}


export default CalendarPage;




// WEBPACK FOOTER //
// ./src/components/Site/SiteRoot/Navigation/LinkPages/CalendarPage.js